import { Button, Form, InputGroup } from 'react-bootstrap';
import { UilTimes } from '@iconscout/react-unicons';
import FormCollapse from 'components/common/FormCollapse';
import {
  availabiltyOptions,
  brandsOptions,
  campaignOptions,
  certificationOptions,
  colorFamilyOptions,
  deliveryOptions,
  displyOptions,
  warrantyOptions,
  warrantyTypeOptions
} from 'data/e-commerce/filterOptions';
import CheckboxItem from 'components/common/CheckboxItem';
import Rating from 'components/base/Rating';
import {
  Brand,
  Category,
  CategoryType,
  SubCategory
} from 'api/categories/_requests';
import { debounce } from 'lodash';

export interface ProductFilter {
  brands: string[];
  categoryType: string | null;
  category: string | null;
  subCategory: string[] | null;
  price: {
    min: number | null;
    max: number | null;
  };
  search: string | null;
}

interface ProductFilterItemsProps {
  brands: Brand[];
  categoryTypes: CategoryType[];
  categories: Category[];
  subCategories: SubCategory[];
  handleClose: () => void;
  filters: ProductFilter;
  setFilters: (filters: ProductFilter) => void;
}

const handleBrandChange = (
  brandId: string,
  filters: ProductFilter,
  setFilters: (filters: ProductFilter) => void
) => {
  setFilters({
    ...filters,
    brands: filters.brands.includes(brandId)
      ? filters.brands.filter(brand => brand !== brandId)
      : [...filters.brands, brandId]
  });
};

const handleCategoryChange = (
  categoryId: string,
  filters: ProductFilter,
  setFilters: (filters: ProductFilter) => void
) => {
  if (filters.category === categoryId) {
    setFilters({ ...filters, category: null });
  } else {
    setFilters({ ...filters, category: categoryId });
  }
};

const handleCategoryTypeChange = (
  categoryTypeId: string,
  filters: ProductFilter,
  setFilters: (filters: ProductFilter) => void
) => {
  if (filters.categoryType === categoryTypeId) {
    setFilters({ ...filters, categoryType: null });
  } else {
    setFilters({ ...filters, categoryType: categoryTypeId });
  }
};

const handleSubCategoryChange = (
  subCategoryId: string,
  filters: ProductFilter,
  setFilters: (filters: ProductFilter) => void
) => {
  setFilters({
    ...filters,
    subCategory: filters.subCategory?.includes(subCategoryId)
      ? filters.subCategory?.filter(
          subCategory => subCategory !== subCategoryId
        )
      : [...(filters.subCategory || []), subCategoryId]
  });
};

const debouncedPriceChange = debounce(
  (
    price: { min: number | null; max: number | null },
    filters: ProductFilter,
    setFilters: (filters: ProductFilter) => void
  ) => {
    setFilters({ ...filters, price });
  },
  500
);

const ProductFilterItems = ({
  brands,
  categories,
  subCategories,
  categoryTypes,
  handleClose,
  filters,
  setFilters
}: ProductFilterItemsProps) => {
  return (
    <>
      <div className="d-flex justify-content-between align-items-center mb-3">
        <h3 className="mb-0">Filters</h3>
        <button className="btn p-0 d-lg-none" onClick={handleClose}>
          <UilTimes size={16} />
        </button>
      </div>

      <div className="card p-2 mb-2">
        <FormCollapse title="Brands">
          <div
            style={{
              maxHeight: '300px',
              overflowY: 'auto',
              scrollbarWidth: 'none', // Firefox
              msOverflowStyle: 'none' // IE 10+
            }}
            className="px-1 position-relative"
          >
            {/* <style>
            {`
        div::-webkit-scrollbar {
          display: none;
        }
      `}
          </style> */}

            {brands.map(item => (
              <CheckboxItem
                name={item.name}
                value={item._id}
                label={item.name}
                key={item._id}
                checked={filters.brands.includes(item._id)}
                onChange={() =>
                  handleBrandChange(item._id, filters, setFilters)
                }
              />
            ))}
          </div>
        </FormCollapse>
      </div>
      <div className="card p-2 mb-2">
        <FormCollapse title="Category Types">
          <div
            style={{
              maxHeight: '300px',
              overflowY: 'auto',
              scrollbarWidth: 'none', // Firefox
              msOverflowStyle: 'none' // IE 10+
            }}
            className="px-1 position-relative"
          >
            {/* <style>
            {`
        div::-webkit-scrollbar {
          display: none;
        }
      `}
          </style> */}
            {categoryTypes.map(item => (
              <CheckboxItem
                name={item.name}
                value={item._id}
                label={item.name}
                key={item._id}
                checked={filters.categoryType === item._id}
                onChange={() =>
                  handleCategoryTypeChange(item._id, filters, setFilters)
                }
              />
            ))}
          </div>
        </FormCollapse>
      </div>

      {filters.categoryType && (
        <div className="card p-2 mb-2">
          <FormCollapse title="Categories">
            <div
              style={{
                maxHeight: '300px',
                overflowY: 'auto',
                scrollbarWidth: 'none', // Firefox
                msOverflowStyle: 'none' // IE 10+
              }}
              className="px-1 position-relative"
            >
              {/* <style>
            {`
        div::-webkit-scrollbar {
          display: none;
        }
      `}
          </style> */}
              {categories.map(item => (
                <CheckboxItem
                  name={item.name}
                  value={item._id}
                  label={item.name}
                  key={item._id}
                  checked={filters.category === item._id}
                  onChange={() =>
                    handleCategoryChange(item._id, filters, setFilters)
                  }
                />
              ))}
            </div>
          </FormCollapse>
        </div>
      )}

      {filters.category && (
        <div className="card p-2 mb-2">
          <FormCollapse title="Sub Categories">
            <div
              style={{
                maxHeight: '300px',
                overflowY: 'auto',
                scrollbarWidth: 'none', // Firefox
                msOverflowStyle: 'none' // IE 10+
              }}
              className="px-1 position-relative"
            >
              {/* <style>
            {`
        div::-webkit-scrollbar {
          display: none;
        }
      `}
          </style> */}
              {subCategories.map(item => (
                <CheckboxItem
                  name={item.name}
                  value={item._id}
                  label={item.name}
                  key={item._id}
                  checked={filters.subCategory?.includes(item._id)}
                  onChange={() =>
                    handleSubCategoryChange(item._id, filters, setFilters)
                  }
                />
              ))}
            </div>
          </FormCollapse>
        </div>
      )}
      <div className="card p-2 mb-2">
        <FormCollapse title="Availability">
          {availabiltyOptions.map(item => (
            <CheckboxItem
              name={item.name}
              value={item.value}
              label={item.label}
              key={item.value}
            />
          ))}
        </FormCollapse>
      </div>
      <div className="card p-2 mb-2">
        <FormCollapse title="Color family">
          {colorFamilyOptions.map(item => (
            <CheckboxItem
              name={item.name}
              value={item.value}
              label={item.label}
              key={item.value}
            />
          ))}
        </FormCollapse>
      </div>
      <div className="card p-2 mb-2">
        <FormCollapse title="Price range">
          <div className="d-flex gap-2">
            <InputGroup>
              <Form.Control
                placeholder="Min"
                onChange={e =>
                  debouncedPriceChange(
                    {
                      min: Number(e.target.value),
                      max: filters.price.max
                    },
                    filters,
                    setFilters
                  )
                }
              />
              <Form.Control
                placeholder="Max"
                onChange={e =>
                  debouncedPriceChange(
                    {
                      min: filters.price.min,
                      max: Number(e.target.value)
                    },
                    filters,
                    setFilters
                  )
                }
              />
            </InputGroup>
          </div>
        </FormCollapse>
      </div>
      <div className="card p-2 mb-2">
        <FormCollapse title="Rating">
          {[5, 4, 3, 2, 1].map(rating => (
            <CheckboxItem
              type="radio"
              value={rating}
              key={rating}
              name="rating"
              label={
                <div className="d-flex align-items-center ms-1">
                  <Rating
                    style={{ color: 'red' }}
                    initialValue={rating}
                    readonly
                    iconClass="fs-9 me-1"
                  />
                  {rating < 5 && <p className="ms-1 mt-1 mb-0">&amp; above</p>}
                </div>
              }
            />
          ))}
        </FormCollapse>
      </div>
      <div className="card p-2 mb-2">
        <FormCollapse title="Display type">
          {displyOptions.map(item => (
            <CheckboxItem
              name={item.name}
              value={item.value}
              label={item.label}
              key={item.value}
            />
          ))}
        </FormCollapse>
      </div>
      <div className="card p-2 mb-2">
        <FormCollapse title="Delivery">
          {deliveryOptions.map(item => (
            <CheckboxItem
              name={item.name}
              value={item.value}
              label={item.label}
              key={item.value}
            />
          ))}
        </FormCollapse>
      </div>
      <div className="card p-2 mb-2">
        <FormCollapse title="Campaign">
          {campaignOptions.map(item => (
            <CheckboxItem
              name={item.name}
              value={item.value}
              label={item.label}
              key={item.value}
            />
          ))}
        </FormCollapse>
      </div>
      <div className="card p-2 mb-2">
        <FormCollapse title="Warranty">
          {warrantyOptions.map(item => (
            <CheckboxItem
              name={item.name}
              value={item.value}
              label={item.label}
              key={item.value}
            />
          ))}
        </FormCollapse>
      </div>
      <div className="card p-2 mb-2">
        <FormCollapse title="Warranty Type">
          {warrantyTypeOptions.map(item => (
            <CheckboxItem
              name={item.name}
              value={item.value}
              label={item.label}
              key={item.value}
            />
          ))}
        </FormCollapse>
      </div>
      <div className="card p-2 mb-2">
        <FormCollapse title="Certification">
          {certificationOptions.map(item => (
            <CheckboxItem
              name={item.name}
              value={item.value}
              label={item.label}
              key={item.value}
            />
          ))}
        </FormCollapse>
      </div>
    </>
  );
};

export default ProductFilterItems;
